import styled from 'styled-components';

export const SigninMarksLoaderContainer = styled.div`
  height: 200px;
  position: relative;
  .anticon.anticon-loading{
    font-size: 60px;
    left: 45%;
    position: absolute;
    top: 30%;
  }
`;
